import { render, staticRenderFns } from "./sf-list.vue?vue&type=template&id=92b3872e&scoped=true&"
import script from "./sf-list.vue?vue&type=script&lang=ts&"
export * from "./sf-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b3872e",
  null
  
)

export default component.exports